import './GenericCard.css'

import React, {
  useMemo,
  useState
} from 'react'

import { AvatarData } from 'components/Avatar/Avatar'

import { iconName } from '../Icon2/constants'
import Icon from '../Icon2/Icon'
import { Truncate } from '../Truncate/Truncate'
import { GenericCardV2 } from './GenericCardV2'

const VERSION_2: 'v2' = 'v2'

export type GenericCardProps = {
  title?: string
  active?: boolean
  mainContent?: JSX.Element
  footerContent?: JSX.Element
  data?: any
  onActiveToggle: (state: any, event?: any) => void
  disableActiveFn?: boolean
  width?: number
  testId?: string
  version?: typeof VERSION_2
  avatars?: AvatarData[]
  modified?: string
  type?: 'text' | 'image'
  icons?: JSX.Element
  lastModifiedTooltipContent?: string
  modifiedAtTooltipText?: string
}

const GenericCardFooter = ({ content }) => {
  return useMemo(() => {
    return (
      <div className="StackCard__footer GenericCardfooter">
        {content}
      </div>
    )
  }, [content])
}

const GenericCard = (props: GenericCardProps) => {

  let { title, active = false, onActiveToggle = (state, event) => { }, mainContent, footerContent, data = "", disableActiveFn = false, width = 20, testId = "cs-generic-card", version } = props;

  let [isActive, setIsActive] = useState(active);

  const handleStarClick = (event: any) => {
    event.stopPropagation();
    setIsActive(!isActive);
    onActiveToggle({ isActive: !isActive, data });
  };

  if (version === VERSION_2) {
    return <GenericCardV2 {...props} />
  }

  return (
    <div className="GenericCard" style={{ width: `${width}rem` }} data-test-id={testId}>
      <div className="GenericCard__heading">
        <h4 className="GenericCard__title"
          aria-label='title'>
          {title?.length > 22 ? (
            <Truncate maxChar={22}>{title}</Truncate>
          ) : title}
          {!disableActiveFn && <button
            aria-label='star-button'
            className="GenericCard__star-button"
            onClick={handleStarClick}
          >
            <Icon
              icon={iconName.Star}
              className={`StackCard__star-icon${isActive ? ' StackCard__star-icon--active' : ''}`}
            ></Icon>
          </button>}
        </h4>
      </div>
      <div className="StackCard__content">
        {mainContent}
      </div>
      <GenericCardFooter content={footerContent} />
    </div>
  )
}

export default GenericCard